import { BadgeVariant } from "@/components/ui/Badge";
import type { RequestLogStatus } from "@/types/request-status";

export const STATUS_CHIP_VARIANT: Record<string, BadgeVariant> = {
  SUCCESS: BadgeVariant.GREEN,
  WARNING: BadgeVariant.AMBER,
  ERROR: BadgeVariant.RED,
};

export const STATUS_CHIP_LABEL: Record<RequestLogStatus, string> = {
  SUCCESS: "Success",
  WARNING: "Warning",
  ERROR: "Error",
};

export const formatStatusValues = (value: string | string[]): string => {
  if (Array.isArray(value)) {
    return value.map(v => STATUS_CHIP_LABEL[v as RequestLogStatus] ?? v).join(", ");
  }
  return STATUS_CHIP_LABEL[value as RequestLogStatus] ?? String(value);
};
